import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"
import { logout } from './userSlice';


export const initialState = {
  dashboard: {
    analytics: [],
    appointments: [],
    graph: {},
  },
  error: null,
  loader: false,
  featured: {},
  current_page: 1,
  per_page: PAGELENGTH
}

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: initialState,
  reducers: {
    setDashboardAnalytic: (state, { payload }) => {
      state.dashboard = payload?.data ?? payload;
    },
    setGraphData: (state, { payload }) => {
      state.dashboard.graph = payload;
    },
    setDashboardAnalytics: (state, { payload }) => {
      state.dashboard.analytics = payload;
    },
    setDashboardAppointments: (state, { payload }) => {
        state.dashboard.appointments = payload?.data;
        state.total = payload?.total;
        state.is_more = payload?.is_more;
        state.last_page = payload?.last_page;
        state.current_page = payload?.current_page;
        state.per_page = payload?.per_page
    },
    removerVendorReports: (state, { payload }) => {
      state.error = payload
    },
    clearAllDashboard: (state, { payload }) => {
        state.loader = payload
    },
    setError: (state, { payload }) => {
        state.error = payload
    },
    setLoader: (state, { payload }) => {
        state.loader = payload
    },
  }
})


export const fetchDashboardAnalytics = (params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {
      
      const result = await Api.fetchClientDashboardAnalytics(params)
      if (result.status >= 200 && result.status < 300) {
          dispatch(setDashboardAnalytics(result.data.data));
    }
    else if (result?.status == 422) {
        dispatch(setError(result.data))
    }
    else if(result?.status == 401){
      dispatch(setError("Unauthorized"))
      dispatch(logout())
    }
  } catch (error) {
    console.log("error", error)
    
  }
  !disableLoader && dispatch(setLoader(false))
}




export const downloadDashboardReport = (filters, callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.downloadDashboardReport(filters);
    dispatch(setLoader(false));

    if (result.status >= 200 && result.status < 300) {
   
      callback(true, result.data);
    } else {

      callback(false, result.data);
    }
  } catch (error) {
    console.error("Download Dashboard Report Error:", error);
    dispatch(setLoader(false));
    callback(false, error?.response?.data || { message: "Something went wrong" });
  }
};



export const fetchDashboardAppointments = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

      const result = await Api.fetchClientDashboardAppointment(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setDashboardAppointments(result.data.data));
      } else {
        dispatch(setDashboardAppointments(result.data.data));
      }
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
    else if(result?.status == 401){
      dispatch(setError("Unauthorized"))
      dispatch(logout())
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader &&  dispatch(setLoader(false))
}

export const fetchDashboardGraph = (params = {}) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.fetchGraphData(params);
    if (result.status >= 200 && result.status < 300) {
      dispatch(setGraphData(result.data.data));
    }
  } catch (error) {
    dispatch(setError(error));
  }
  dispatch(setLoader(false));
};


export const { setDashboardAnalytics, clearAllDashboard, setLoader, setError ,setDashboardAppointments , setGraphData} = dashboardSlice.actions

export default dashboardSlice.reducer
export const DashboardSelector = state => state.dashboard

export const adminAddTravelTime = (data, callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.adminAddTravelTime(data);
    if (result?.status >= 200 && result?.status < 300) {
      callback(true, result.data?.message || 'Travel time added successfully.');
    } else {
      callback(false, result?.data?.message || 'Something went wrong');
    }
  } catch (error) {
    callback(false, 'Server error');
  }
  dispatch(setLoader(false));
};

export const adminEditTravelTime = (id, data, callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.adminEditTravelTime(id, data);
    if (result?.status >= 200 && result?.status < 300) {
      callback(true, result.data?.message || 'Travel time updated successfully.');
    } else {
      callback(false, result?.data?.message || 'Something went wrong');
    }
  } catch (error) {
    callback(false, 'Server error');
  }
  dispatch(setLoader(false));
};

export const adminDeleteTravelTime = (id, callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.adminDeleteTravelTime(id);
    if (result?.status >= 200 && result?.status < 300) {
      callback(true, result.data?.message || 'Travel time deleted successfully.');
    } else {
      callback(false, result?.data?.message || 'Something went wrong');
    }
  } catch (error) {
    callback(false, 'Server error');
  }
  dispatch(setLoader(false));
};

export const adminAddDayOff = (data, callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.adminAddDayOff(data);
    if (result?.status >= 200 && result?.status < 300) {
      callback(true, result.data?.message || 'Day off added successfully.');
    } else {
      callback(false, result?.data?.message || 'Something went wrong');
    }
  } catch (error) {
    callback(false, 'Server error');
  }
  dispatch(setLoader(false));
};

export const adminEditDayOff = (id, data, callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.adminEditDayOff(id, data);
    if (result?.status >= 200 && result?.status < 300) {
      callback(true, result.data?.message || 'Day off updated successfully.');
    } else {
      callback(false, result?.data?.message || 'Something went wrong');
    }
  } catch (error) {
    callback(false, 'Server error');
  }
  dispatch(setLoader(false));
};

export const adminDeleteDayOff = (id, callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.adminDeleteDayOff(id);
    if (result?.status >= 200 && result?.status < 300) {
      callback(true, result.data?.message || 'Day off deleted successfully.');
    } else {
      callback(false, result?.data?.message || 'Something went wrong');
    }
  } catch (error) {
    callback(false, 'Server error');
  }
  dispatch(setLoader(false));
};

export const adminEditLunch = (id, data, callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.adminEditLunch(id, data);
    if (result?.status >= 200 && result?.status < 300) {
      callback(true, result.data?.message || 'Lunch updated successfully.');
    } else {
      callback(false, result?.data?.message || 'Something went wrong');
    }
  } catch (error) {
    callback(false, 'Server error');
  }
  dispatch(setLoader(false));
};

export const adminDeleteLunch = (id, callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.adminDeleteLunch(id);
    if (result?.status >= 200 && result?.status < 300) {
      callback(true, result.data?.message || 'Lunch deleted successfully.');
    } else {
      callback(false, result?.data?.message || 'Something went wrong');
    }
  } catch (error) {
    callback(false, 'Server error');
  }
  dispatch(setLoader(false));
};



